/**
 * User-friendly error message mapping
 * Converts technical error messages to human-readable ones
 */

const ERROR_MAP = {
  'Body is disturbed or locked': 'Unable to connect to the server. Please check your internet connection and try again.',
  'body stream already read': 'Connection error. Please try again.',
  'Response body is already used': 'Connection error. Please try again.',
  "Failed to execute 'clone' on 'Response'": 'Connection error. Please try again.',
  'Failed to fetch': 'Unable to connect to the server. Please check your internet connection and try again.',
  'NetworkError': 'Network error occurred. Please check your connection and try again.',
  'Network request failed': 'Network error occurred. Please check your connection and try again.',
  'Request aborted': 'The request was interrupted. Please try again.',
  'Load failed': 'Failed to load data. Please refresh the page and try again.',
  'TypeError: Failed to fetch': 'Unable to connect to the server. Please check your internet connection and try again.',
  'AbortError': 'The request was cancelled. Please try again.',
  'TimeoutError': 'The request timed out. Please try again.',
  'net::ERR_FAILED': 'Network error. Please check your connection and try again.',
  'net::ERR_CONNECTION_REFUSED': 'Unable to connect to server. Please try again later.',
  'net::ERR_INTERNET_DISCONNECTED': 'No internet connection. Please check your network and try again.',
};

/**
 * Converts technical error messages to user-friendly messages
 * @param {string} errorMessage - The original error message
 * @returns {string} - A user-friendly error message
 */
export const getUserFriendlyError = (errorMessage) => {
  if (!errorMessage) {
    return 'An unexpected error occurred. Please try again.';
  }

  // Check if the error message contains any of the mapped errors
  for (const [key, value] of Object.entries(ERROR_MAP)) {
    if (errorMessage.includes(key)) {
      return value;
    }
  }
  
  // Return the original message if it seems user-friendly already
  // (doesn't contain technical jargon)
  const technicalPatterns = [
    /^[A-Z][a-z]+Error:/,
    /undefined/i,
    /null/i,
    /cannot read/i,
    /is not a function/i,
    /unexpected token/i,
  ];
  
  const isTechnical = technicalPatterns.some(pattern => pattern.test(errorMessage));
  
  if (isTechnical) {
    return 'An unexpected error occurred. Please try again or contact support if the issue persists.';
  }
  
  return errorMessage;
};

export default getUserFriendlyError;
